// import { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchUserPermissions, setCurrentModule, selectCurrentModulePermissions } from '../redux/permissionsSlice';

// export const usePermissions = (moduleName) => {
//   const dispatch = useDispatch();
//   const permissions = useSelector(selectCurrentModulePermissions);

//   useEffect(() => {
//     const userId = sessionStorage.getItem("UserId");
//     if (userId) {
//       dispatch(fetchUserPermissions(userId));
//     }
//     dispatch(setCurrentModule(moduleName));
//   }, [dispatch, moduleName]);

//   return permissions;
// };




import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserPermissions, selectPermissionsByModule, selectPermissionsStatus } from '../redux/permissionsSlice';

export const usePermissions = (moduleName) => {
  const dispatch = useDispatch();
  const status = useSelector(selectPermissionsStatus);
  const permissions = useSelector(state => selectPermissionsByModule(state, moduleName));

  useEffect(() => {
    const userId = sessionStorage.getItem("UserId");
    if (userId && status === 'idle') {
      dispatch(fetchUserPermissions(userId));
    }
  }, [dispatch, status]);

  return permissions;
};